/** Google-specific scope and import support; shared source policies live in providers.ts. */
export const GOOGLE_DRIVE_FILE_SCOPE = 'https://www.googleapis.com/auth/drive.file'
export const GOOGLE_DOC_MIME_TYPE = 'application/vnd.google-apps.document'

export const GOOGLE_DRIVE_SUPPORTED_MIME_TYPES = [
  GOOGLE_DOC_MIME_TYPE,
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
  'text/markdown',
] as const

export function isSupportedGoogleDriveFile(mimeType: string): boolean {
  return GOOGLE_DRIVE_SUPPORTED_MIME_TYPES.some(supported => supported === mimeType)
}
